module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"From","to":"To","departure":"Planned departure","arrival":"Planned arrival"},"no":{"from":"Fra","to":"Til","departure":"Planlagt avgang","arrival":"Planlagt ankomst"}}')
  delete Component.options._Ctor
}
